
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rewards-page",
      function () {
        return require("private-next-pages/rewards-page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rewards-page"])
      });
    }
  